import React, { useEffect, useRef, useState } from "react"
import styles from "./index.module.scss"

export default function Address({ form, label, setForm, loading, data, modalOpen }) {
  const autocompleteInputRef = useRef(null);
  const [autocomplete, setAutocomplete] = useState(null);
  const [inputValue, setInputValue] = useState(form[label]);
  const [timerId, setTimerId] = useState(null);

  const handleInputChange = (event) => {
    clearTimeout(timerId);
    setInputValue(event.target.value);

    setTimerId(setTimeout(() => {
      if (window.google && !autocomplete) {
        const autocompleteInstance = new window.google.maps.places.Autocomplete(autocompleteInputRef.current);
        setAutocomplete(autocompleteInstance);
      }
    }, 1000)); // Delay of 1000ms
  };

  useEffect(() => {
    if (autocomplete) {
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        const formattedAddress = place.formatted_address;
        setForm(prevForm => ({ ...prevForm, [label]: formattedAddress }));
      });
    }
  }, [autocomplete, setForm, label]);

  useEffect(() => {
    if (form[label]) {
      autocompleteInputRef.current.value = form[label];
    }
  }, [form]);

  return (
    <div
    style={{ position: "relative", overflow: "unset" }}
    className={styles.container}
  >
    <input ref={autocompleteInputRef} type="text" placeholder="  Address" onChange={handleInputChange} />
    </div>
  );
}
